import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext.js";
import "../styles/Login.css";
import { apiFetch } from "../api.js";

const Login = () => {
  const [formData, setFormData] = useState({
    companyCode: "",
    userId: "",
    password: "",
    otp: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [checkingCompany, setCheckingCompany] = useState(false);
  const [checkingUser, setCheckingUser] = useState(false);
  const [userType, setUserType] = useState("");

  const navigate = useNavigate();
  const { login } = useContext(UserContext);
  const [dbName, setDbName] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // ✅ Company validation
  const handleCompanyBlur = async () => {
    if (!formData.companyCode.trim()) return;

    setCheckingCompany(true);

    try {
      const response = await apiFetch(
        "/api/validate-company", // 🔥 FIX URL
        {
          method: "POST",
          body: JSON.stringify({
            companyCode: formData.companyCode,
          }),
        },
      );

      const data = await response.json();

      if (!data.databaseName) {
        setErrors((p) => ({
          ...p,
          companyCode: "Invalid company code",
        }));
      } else {
        setDbName(data.databaseName);
      }
    } catch (error) {
      console.error("Company validation error:", error);

      setErrors((p) => ({
        ...p,
        companyCode: "Unable to verify company code",
      }));
    } finally {
      setCheckingCompany(false);
    }
  };

  // ✅ Username validation
  const handleUserBlur = async () => {
    if (!formData.userId.trim()) return;

    setCheckingUser(true);
    try {
      const res = await fetch(
        "/api/validate-username",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: formData.userId, dbName: dbName }),
        },
      );

      const data = await res.json();
      if (!data.userType) {
        setErrors((p) => ({ ...p, userId: "Invalid user ID" }));
        setUserType("");
      } else {
        setUserType(data.userType);
      }
    } catch {
      setErrors((p) => ({ ...p, userId: "Unable to verify user ID" }));
      setUserType("");
    } finally {
      setCheckingUser(false);
    }
  };

  const validateForm = () => {
    const e = {};
    if (!formData.companyCode) e.companyCode = "Required";
    if (!formData.userId) e.userId = "Required";
    if (userType === "normal" && !formData.password) e.password = "Required";
    if (userType === "otp" && !formData.otp) e.otp = "Required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // ✅ LOGIN (same as previous working)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyCode: formData.companyCode,
          uti: formData.userId,
          utp: userType === "normal" ? formData.password : formData.otp,
        }),
      });

      const data = await res.json();

      /* if (data.success) {
        login({
          userId: formData.userId,
          companyCode: formData.companyCode,
          propertyCode: data.propertyCode || "",
        });

        navigate("/dashboard");
      } */
      if (data.success) {
        localStorage.setItem("token", data.token);
        login({
          userId: formData.userId,
          companyCode: formData.companyCode,
          propertyCode: data.propertyCode || "",
        });

        navigate("/dashboard");
      } else {
        setErrors({ general: data.message || "Login failed" });
      }
    } catch {
      setErrors({ general: "Server error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* 🎨 HERO FROM NEW DESIGN */}
      <div className="login-hero">
        <div className="hero-animation">
          <h1 className="hero-text">
            <span className="hero-my">MY</span>
            <span className="hero-autoshop">AUTOSHOP</span>
          </h1>
        </div>
      </div>

      {/* 🎨 STYLED LOGIN CARD */}
      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <h1>Guljag</h1>
            <div className="logo-divider"></div>
            <p>Sign in to your account</p>
          </div>

          {errors.general && (
            <div className="error-message general-error">{errors.general}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                name="companyCode"
                placeholder="Company Code"
                value={formData.companyCode}
                onChange={handleChange}
                onBlur={handleCompanyBlur}
              />
              {checkingCompany && <small>Checking...</small>}
              {errors.companyCode && <span>{errors.companyCode}</span>}
            </div>

            <div className="form-group">
              <input
                name="userId"
                placeholder="User ID"
                value={formData.userId}
                onChange={handleChange}
                onBlur={handleUserBlur}
              />
              {checkingUser && <small>Checking...</small>}
              {errors.userId && <span>{errors.userId}</span>}
            </div>

            <div className="form-group">
              {userType === "otp" ? (
                <input
                  name="otp"
                  placeholder="Enter OTP"
                  value={formData.otp}
                  onChange={handleChange}
                />
              ) : (
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                />
              )}
              {errors.password && <span>{errors.password}</span>}
              {errors.otp && <span>{errors.otp}</span>}
            </div>

            <button className="login-btn" type="submit" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
